<!-- 一般ユーザー　パスワード忘れた方-->
<style src="@/assets/css/login_parts.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_input.css" type="text/css" media="all" scoped></style>
<style　scoped>

</style>
<template>
	<!-- ▼ contents -->
	<div id="login" v-bind:style="getStyle">
		<!-- ▼ header  -->
		<section id="loginHeader">
			<h1>{{irnm}}</h1>
			<h2>WEB健診予約システム</h2>
			<p>Online Reservation Service</p>
		</section>
		<!-- ▲ header END -->
		<!-- ▽  -->
			<section class="pw">
				<h3>パスワードをお忘れの方</h3>
				<p>メールアドレスと生年月日を入力してください。<br>パスワードが再発行されます。</p>
				<dl>
					<dt>メールアドレス</dt>
					<dd><input type="text" class="eMail" v-model="inputForm.email"></dd>
					<dt>生年月日</dt>
					<dd class="dayForm">
						<ul>
							<li>
								<select v-model="inputForm.btdyYear">
									<option value=0>選択</option>
									<option v-for="item in inputForm.listBtdyYear" v-bind:key="item">
										{{item}}
									</option>
								</select>
							</li>
							<li>
								<select v-model="inputForm.btdyMonth">
									<option value=0>選択</option>
									<option v-for="item in inputForm.listBtdyMonth" v-bind:key="item">
										{{item}}
									</option>
								</select>
							</li>
							<li>
								<!-- 選んだ生年月日　年及び月に依存 -->
								<select v-model="inputForm.btdyDate">
									<option value=0>選択</option>
									<option v-for="item in computedListBtdyDate" v-bind:key="item">
										{{item}}
									</option>
								</select>
							</li>
						</ul>
					</dd>
				</dl>
				<div class="btnLst">
					<button class="backBtn"  v-on:click="onBack">戻る</button>
					<button class="pwBtn" v-on:click="onReissuePasswordConfirmModalOpen">パスワードを再発行する</button>
				</div>
			</section>
			<!-- △ mainContents END -->
		<section class="mainCF">
		</section>
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.reissuePasswordStart.isShow" v-on:close="onReissuePasswordStartModalClose">
			<dt slot="modal-header">再発行処理中</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.reissuePasswordStart.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.reissuePasswordConfirm.isShow" v-on:close="onReissuePasswordConfirmModalClose">
			<dt slot="modal-header">再発行確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.reissuePasswordConfirm.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer">
				<button class="cancelBtn" v-on:click="onReissuePassword">再発行する</button>
				<button class="backBtn" v-on:click="onReissuePasswordConfirmModalClose">閉じる</button>
			</dd>
		</modalWindow>
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.notIntegratedError.isShow" v-on:close="onNotIntegratedErrorModalClose">
			<dt slot="modal-header">データ不整合エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.notIntegratedError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onNotIntegratedErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>
<script>
	import { CommonForgetPassword } from '@/api'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
	import * as UtilityValidation from '@/components/Utility/UtilitiValidation'
	import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		// モジュール名
		name: 'CommonForgetPassword',
		// 使用コンポーネント
		components: {
			// エラー表示コンポーネント
			'errorMessageBox': ErrorMessageBox,
			// モーダルウィンドウ表示コンポーネント
			'modalWindow': ModalWindow
		},
		// 算出プロパティ
		computed: {
			// 生年月日　日付のプルダウン内容を生成
			computedListBtdyDate: function () {

				var tempListBtdyDate = []

				// 当月の最終日の求め方
				// 本来8月なら第二引数（月）は7を与えるべきだが
				// 本来8月なら第三引数（日）に0を与えて
				// 次月の最初の日（1日）より一日前（0日）で
				// 当月の最終日を求める
				var lastDate = new Date(
					this.inputForm.btdyYear,
					this.inputForm.btdyMonth, 0).getDate()

				for (var i = 1; i <= lastDate; i++) {
					tempListBtdyDate.push(i)
				}

				return tempListBtdyDate
			},
			getStyle: function() {

    	  var resultStyle = ''

    	  var strPre = "background-image: url('"
    	  var strPost = "');"

    	  if(this.$store.state.commonUserInfo.hmpg != '') {
    	    resultStyle =  strPre + this.$store.state.commonUserInfo.hmpg + strPost
    	  }

    	  return resultStyle
    	}
		},
		// データ
		data() {
			return {

				// 医療機関名称
				irnm: '',

				inputForm: {
					// ユーザーID（メールアドレス）
					email: '',
					// 生年月日　年
					btdyYear: 0,
					// 生年月日　月
					btdyMonth: 0,
					// 生年月日　日付
					btdyDate: 0,
					// 生年月日　年のプルダウン内容
					listBtdyYear:[],
					// 生年月日　月のプルダウン内容
					listBtdyMonth: [
						1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
					],
				},
				// モーダルウィンドウ
				modal: {
					// パスワード再発行
					reissuePasswordStart: {
						messages: [
							'パスワード再発行中です。'
						],
						isShow: false
					},
					// パスワード再発行確認
					reissuePasswordConfirm: {
						messages: [
							'パスワードを再発行します。'
						],
						isShow: false
					},
					// 入力エラー
					validationError: {
						messages: [],
						isShow: false
					},
					// データ不整合エラー
					notIntegratedError: {
						messages: [
							'メールアドレスもしくは生年月日が誤っています。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					},
					// システムエラー
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					},
				}
			}
		},
		// ライフサイクルフック: created
		created: function () {
			UtilityConsoleLog.consoleLog('CommonForgetPassword::created Start')

			this.firstDisplay()

			UtilityConsoleLog.consoleLog('CommonForgetPassword::created End')
		},
		methods: {
			// 表示系--------------------------------------------------S
			// 初期表示
			firstDisplay: function () {
				UtilityConsoleLog.consoleLog('CommonForgetPassword::firstDisplay Start')

				// プルダウンの初期値を取得する
				CommonForgetPassword.FirstDisplay({
          ircd: this.$store.state.auth.ircd
        }).then(({responce})=>{
					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						this.inputForm.listBtdyYear = responce.data.listBirthYear
						this.irnm = responce.data.irnm

					} else if(responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						this.onSystemErrorModalOpen()
					}

				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('CommonForgetPassword::firstDisplay End')
				})

			},
			// 表示系--------------------------------------------------E
			// パスワード再発行ボタン押下
			onReissuePassword: function() {
				UtilityConsoleLog.consoleLog('CommonForgetPassword::onReissuePassword Start')

				// 再発行確認モーダルを閉じる
				this.onReissuePasswordConfirmModalClose()
				// 再発行処理中モーダルとしてモーダルを開く
				this.onReissuePasswordStartModalOpen()

				// パスワード再発行
				CommonForgetPassword.ReissuePassword({
					ircd: this.$store.state.auth.ircd,
					email: this.inputForm.email,
					btdyYear: this.inputForm.btdyYear,
					btdyMonth: this.inputForm.btdyMonth,
					btdyDate: this.inputForm.btdyDate
				}).then(({responce})=>{
					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {
						// 再発行処理中モーダルを閉じる
						this.onReissuePasswordStartModalClose()
						// 再発行メール送信完了画面に遷移
						this.$router.push("/CommonForgetPassword2")
					} else if(responce.data.errorCode == ErrorCodes.ERRORCODE_CORRECTION) {
						// データ不整合ダイアログを表示
						this.onNotIntegratedErrorModalOpen()
					} else if(responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('CommonForgetPassword::onReissuePassword End')
				})

			},
			// 戻るボタン押下時
			onBack: function () {
				UtilityConsoleLog.consoleLog('CommonForgetPassword::onBack Start')

					// URLパラム
					var tempParam = this.$store.getters.getCommonParam

					// トップ画面へ遷移
					this.$router.push('/CommonLogin/' + tempParam)

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onBack End')
			},
			// その他--------------------------------------------------S
			// パスワード再発行ボタン押下時入力チェック
			validationOnReissuePassword: function () {

				UtilityConsoleLog.consoleLog('CommonForgetPassword::validationOnReissuePassword Start')

				// エラーメッセージリスト
				var errorMessagesList = []

				var tempErrorMessage = []
				// メールアドレスの入力チェック
				tempErrorMessage = this.validationMailAssress()
				tempErrorMessage.forEach((item) => {
					errorMessagesList.push(item)
				})
				// 生年月日 年の入力チェック
				tempErrorMessage = this.validationBtdyYear()
				tempErrorMessage.forEach((item) => {
					errorMessagesList.push(item)
				})
				// 生年月日 月の入力チェック
				tempErrorMessage = this.validationBtdyMonth()
				tempErrorMessage.forEach((item) => {
					errorMessagesList.push(item)
				})
				// 生年月日　日の入力チェック
				tempErrorMessage = this.validationBtdyDate()
				tempErrorMessage.forEach((item) => {
					errorMessagesList.push(item)
				})

				UtilityConsoleLog.consoleLog('CommonForgetPassword::validationOnReissuePassword End')

				return errorMessagesList
			},
			// メールアドレスの入力チェック
			validationMailAssress: function () {

				UtilityConsoleLog.consoleLog('CommonForgetPassword::validationMailAssress Start')

				var propertyNameMailAssress = 'メールアドレス'
				var lengthUserId = 60

				// エラーメッセージリスト
				var errorMessagesList = []

				if (UtilityValidation.checkStrIsNull(this.inputForm.email)) { // Nullチェック
					errorMessagesList.push(
						UtilityValidation.getErrorMessageCheckStrIsNull(
							propertyNameMailAssress))
				} else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.email)) { // 空文字チェック
					errorMessagesList.push(
						UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
							propertyNameMailAssress))
				} else if (!UtilityValidation.checkStrMaxLength(this.inputForm.email, lengthUserId)) { // 桁数チェック
					errorMessagesList.push(
						UtilityValidation.getErrorMessageCheckStrMaxLength(
							propertyNameMailAssress, String(lengthMailAssress)))
				} else if (!UtilityValidation.checkStrEmail(this.inputForm.email)) { // Email書式チェック
					errorMessagesList.push(
						UtilityValidation.getErrorMessageCheckStrEmail(
							propertyNameMailAssress))
				}

				UtilityConsoleLog.consoleLog('CommonForgetPassword::validationMailAssress End')

				return errorMessagesList
			},
			// 生年月日 年の入力チェック
			validationBtdyYear: function() {
				UtilityConsoleLog.consoleLog('CommonForgetPassword::validationBtdyYear Start')

				var propertyName = '生年月日 年'

				// エラーメッセージリスト
				var errorMessagesList = []

				if(0 == this.inputForm.btdyYear) {
					errorMessagesList.push(
						UtilityValidation.getErrorMessageCheckStrIsNull(
							propertyName))
				}

				UtilityConsoleLog.consoleLog('CommonForgetPassword::validationBtdyYear End')

				return errorMessagesList
			},
			// 生年月日 月の入力チェック
			validationBtdyMonth: function() {
				UtilityConsoleLog.consoleLog('CommonForgetPassword::validationBtdyMonth Start')

				var propertyName = '生年月日　月'

				// エラーメッセージリスト
				var errorMessagesList = []

				// 初期値
				if (0 == this.inputForm.btdyMonth) {
					errorMessagesList.push(
						UtilityValidation.getErrorMessageCheckStrIsNull(
							propertyName))
				}

				UtilityConsoleLog.consoleLog('CommonForgetPassword::validationBtdyMonth End')

				return errorMessagesList
			},
			// 生年月日　日の入力チェック
			validationBtdyDate: function () {

				UtilityConsoleLog.consoleLog('CommonForgetPassword::validationBtdyDate Start')

				var propertyName = '生年月日　日'

				// エラーメッセージリスト
				var errorMessagesList = []

				// 初期値
				if (0 == this.inputForm.btdyDate) {
					errorMessagesList.push(
						UtilityValidation.getErrorMessageCheckStrIsNull(
							propertyName))
				}

				UtilityConsoleLog.consoleLog('CommonForgetPassword::validationBtdyDate End')

				return errorMessagesList
			},
			// 再発行処理中モーダルとしてモーダルを開く
			onReissuePasswordStartModalOpen: function () {

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onReissuePasswordStartModalOpen Start')

				this.modalOpen('reissuePasswordStart')

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onReissuePasswordStartModalOpen End')
			},
			// 再発行処理中モーダルを閉じる
			onReissuePasswordStartModalClose: function () {
				UtilityConsoleLog.consoleLog('CommonForgetPassword::onReissuePasswordStartModalClose Start')

				this.modalClose('reissuePasswordStart')

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onReissuePasswordStartModalClose End')
			},
			// 再発行確認モーダルとしてモーダルを開く
			onReissuePasswordConfirmModalOpen: function () {

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onReissuePasswordConfirmModalOpen Start')

				var errorMessagesList = this.validationOnReissuePassword()

				// 入力チェック
				if (errorMessagesList.length > 0) {
					// 必須入力時エラー
					this.onValidationErrorModalOpen(errorMessagesList)
					UtilityConsoleLog.consoleLog('CommonTop::onReissuePassword End')
					return
				}

				this.modalOpen('reissuePasswordConfirm')

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onReissuePasswordConfirmModalOpen End')
			},
			// 再発行確認モーダルを閉じる
			onReissuePasswordConfirmModalClose: function () {
				UtilityConsoleLog.consoleLog('CommonForgetPassword::onReissuePasswordConfirmModalClose Start')

				this.modalClose('reissuePasswordConfirm')

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onReissuePasswordConfirmModalClose End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			onValidationErrorModalOpen: function (errorMessages) {

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]

				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('CommonForgetPassword::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onValidationErrorModalClose End')
			},
			// データ不整合エラーモーダルとしてエラーモーダルを開く
			onNotIntegratedErrorModalOpen: function (messages) {

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onNotIntegratedErrorModalOpen Start')

				this.modalOpen('notIntegratedError')

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onNotIntegratedErrorModalOpen End')
			},
			// データ不整合エラーモーダルを閉じる
			onNotIntegratedErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('CommonForgetPassword::onNotIntegratedErrorModalClose Start')

				this.modalClose('notIntegratedError')

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onNotIntegratedErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルを閉じる
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('CommonForgetPassword::onSystemErrorModalClose Start')

				this.modalClose('systemError')

				// URLパラム
				var tempParam = this.$store.getters.getCommonParam

				// トップ画面へ遷移
				this.$router.push('/CommonTop/' + tempParam)

				UtilityConsoleLog.consoleLog('CommonForgetPassword::onSystemErrorModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {

				UtilityConsoleLog.consoleLog('CommonForgetPassword::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('CommonForgetPassword::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {

				UtilityConsoleLog.consoleLog('CommonForgetPassword::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('CommonForgetPassword::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
			// その他--------------------------------------------------E
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Common/ForgetPassword/CommonForgetPassword.vue